module.exports = __webpack_public_path__ + "img/seo-accordion-content.854b7b75.png";